module.exports = __webpack_public_path__ + "media/images/top-page_hero-image@1x-b78c3c548d8b4731e4abc0f4928e1c38.jpg";